import React from 'react'
import Tooltip from 'britive-design-system/core/components/tooltip'
import { getSecretStatus } from '../../src/routes/my-requests-my-approvals/utils.js'
import check from 'static/images/check.svg'
import rejectDark from 'static/images/reject-dark.svg'
import noAction from 'static/images/no-action.svg'
import expired from 'static/images/expired.svg'
import pending from 'static/images/pending.svg'
import withdraw from 'static/images/withdraw.svg'

const secretModuleConstants = {
  pendingText: 'pending',
  rejectedText: 'rejected',
  timeOutText: 'timeout',
  approvedText: 'approved',
  cancelledText: 'cancelled',
  withdrawnText: 'withdrawn',
}

const getIcon = status => {
  switch (status?.toLowerCase()) {
    case secretModuleConstants.pendingText:
      return pending

    case secretModuleConstants.approvedText:
      return check

    case secretModuleConstants.rejectedText:
      return rejectDark

    case secretModuleConstants.timeOutText:
      return expired

    case secretModuleConstants.cancelledText:
      return withdraw

    case secretModuleConstants.withdrawnText:
      return withdraw

    default:
      return noAction
  }
}

const StatusIcon = ({ status }) => {
  const fallbackTitle = status?.toLowerCase?.()
  const customTitle =
    typeof getSecretStatus === 'function' ? getSecretStatus(status) : undefined

  const tooltipTitle = customTitle || fallbackTitle
  return (
    <div>
      <Tooltip title={tooltipTitle} position="top">
        <img src={getIcon(status)} />
      </Tooltip>
    </div>
  )
}

export default StatusIcon
